<template>
  <div class="absolute top-0 bottom-0 left-0 right-0 flex flex-row justify-center">
    <div class="spinner text-3xl" />
  </div>
</template>
<script>
export default {
}
</script>
